module.exports = __webpack_public_path__ + "img/monedas64.7a482ab4.png";